export const text = {
  order: "Change Product Order",
};
